import {
    Box,
    Collapse,
    Input,
    InputGroup,
    InputLeftElement,
    InputRightElement,
} from '@chakra-ui/react';
import { WheelEvent } from 'react';
import { CFormError } from '../../../Typography';
import { InputBaseProps } from './Input.types';
// eslint-disable-next-line import/no-cycle
import { useInputBase } from './InputBase.hook';

export const CInputBase = ({
    onChange,
    testId,
    elementSize = '35px',
    inputValue,
    errorText,
    leftElement,
    rightElement,
    isControlledInput = false,
    hideError = false,
    maxW = '100%',
    inputMaxW = '100%',
    ...props
}: InputBaseProps & { inputMaxW?: string }): JSX.Element => {
    const { valueProp, styleProps, handleChange } = useInputBase({
        onChange,
        inputValue,
        errorText,
        leftElement,
        rightElement,
        elementSize,
        isControlledInput,
    });
    return (
        <Box width="100%" maxW={maxW}>
            <InputGroup maxW={inputMaxW}>
                {leftElement && (
                    <InputLeftElement width={elementSize} height="100%">
                        {leftElement}
                    </InputLeftElement>
                )}
                <Input
                    {...props}
                    {...styleProps}
                    {...valueProp}
                    onChange={handleChange}
                    data-test={`${testId}--input`}
                    // This is a workaround to prevent the input value from changing when the user scrolls
                    onWheel={(e: WheelEvent<HTMLInputElement>) =>
                        (e.currentTarget as HTMLInputElement).blur()
                    }
                />
                {rightElement && (
                    <InputRightElement width={elementSize} height="100%">
                        {rightElement}
                    </InputRightElement>
                )}
            </InputGroup>
            <Collapse in={!hideError}>
                <CFormError data-test={`${testId}--error`} text={errorText} />
            </Collapse>
        </Box>
    );
};
